//outsource
import { Input, Form } from "antd";

//components

const ConsultationLastName = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="lastName"
      label="Enter your last name"
      rules={[
        {
          required: true,
          message: "Last name is empty",
        },
      ]}
    >
      <Input placeholder="Last Name" />
    </Form.Item>
  );
};

export default ConsultationLastName;
